
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingBlogAdvisorCardMixins from '~/mixins/eventTrackingBlogAdvisorCardMixin.js';
import whatsappFn from '~/mixins/whatsappFn.js';
import blogAdvisorCardMixin from '~/mixins/blogAdvisorCardMixin.js';
import whatsappQuery from '@/apollo/queries/general/whatsappQuery';

export default {
    name: "BlogAdvisorDesktopCard",    // Mixins provide shared functionality:
    // - eventTrackingMixins: General event tracking utilities
    // - eventTrackingBlogAdvisorCardMixins: Specific blog advisor card tracking
    // - whatsappFn: WhatsApp integration utilities  
    // - blogAdvisorCardMixin: Shared methods using utility helpers from ~/utils/blogAdvisorHelpers
    mixins: [eventTrackingMixins, eventTrackingBlogAdvisorCardMixins, whatsappFn, blogAdvisorCardMixin],

    props: {
        advisorProfilePicture: {
            type: String,
            required: true
        },
        advisorName: {
            type: String,
            required: true
        },
        advisorCompany: {
            type: String,
            required: true
        },
        advisorProfile: {
            type: String,
            required: true
        },
        advisorContact: {
            type: String,
            required: true
        },
        advisorId: {
            type: Number,
            required: true
        },
        advisorRegistrationNo: {
            type: String,
            required: true
        }
    },

    apollo: {
        $loadingKey: 'loading',
        whatsappMsg: {
            prefetch: true,
            query: whatsappQuery,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
            },
            update(data) {
                return this.$normalizeStrapi(data.whatsappWidgetItems);
            },
        },
    },

    data() {
        return {};
    },

    computed: {
        enqueryImgPath() {
            return require(`@/assets/images/advisor-blog/whatsapp-icon-desktop-${this.$i18n.locale}.png`)
        },
        msgText() {
            return `${this.whatsappUrl}${encodeURIComponent(this.msg)}`;
        },
        whatsappUrl() {
            return `https://api.whatsapp.com/send/?phone=852${this.advisorContact}&text=`;
        } 
    },    methods: {
        // Methods showAdvisorProfile(), openWhatsapp(), and getBlogFirstTag() 
        // are provided by blogAdvisorCardMixin using utility helpers
        // Business logic: ~/utils/blogAdvisorHelpers.js
        // Mixin implementation: ~/mixins/blogAdvisorCardMixin.js
    },
}
